/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
	AppConfigActionTypes,
	GET_APP_CONFIGS_FAILURE,
	GET_APP_CONFIGS_REQUEST,
	GET_APP_CONFIGS_SUCCESS,
	GetAppConfigsFailureAction,
	GetAppConfigsRequestAction,
	GetAppConfigsSuccessAction
} from './AppConfigActionTypes';
import { AppConfigState, initialAppConfigState } from './AppConfig.state';

const getAppConfigsRequest = (state: AppConfigState, action: GetAppConfigsRequestAction): AppConfigState => {
	return {
		...state,
		list: {
			...state.list,
			loading: true,
			error: null
		}
	};
};

const getAppConfigsSuccess = (state: AppConfigState, action: GetAppConfigsSuccessAction): AppConfigState => {
	return {
		...state,
		list: {
			...state.list,
			loading: false,
			appConfigs: action.appConfigs
		}
	};
};

const getAppConfigsFailure = (state: AppConfigState, action: GetAppConfigsFailureAction): AppConfigState => {
	return {
		...state,
		list: {
			...state.list,
			loading: false,
			error: action.error
		}
	};
};

const reducer = (state = initialAppConfigState, action: AppConfigActionTypes): AppConfigState => {
	switch (action.type) {
		case GET_APP_CONFIGS_REQUEST:
			return getAppConfigsRequest(state, action);
		case GET_APP_CONFIGS_SUCCESS:
			return getAppConfigsSuccess(state, action);
		case GET_APP_CONFIGS_FAILURE:
			return getAppConfigsFailure(state, action);
		default:
			return state;
	}
};

export default reducer;
